import styled from "styled-components"
import { colors } from "../../../../lib/colors"
import {
  ACTION_STYLED_PROPS,
  HISTORY_STYLED_PROPS,
  CARD_STYLED_PROPS,
} from "./interface"

import {
  cardChangeAnimation,
  cardApearAnimation,
} from "../../../../animations/Transitions"

export const CardDiv = styled.div<CARD_STYLED_PROPS>`
  /* ${({ changeCard }) => changeCard && cardApearAnimation}; */
  position: relative;
  .result {
    position: absolute;
    bottom: -30px;
    right: 50%;
    transform: translateX(50%);
    font-size: 12px;
    text-transform: uppercase;
    color: ${({ winamount }) =>
      winamount ? colors.secondary : colors.secondaryBackground};
  }
`

export const ActionsContainer = styled.div<ACTION_STYLED_PROPS>`
  position: relative;
  .result {
    position: absolute;
    top: -20px;
    right: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    transform: translateX(50%);
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;
    white-space: nowrap;
    color: ${({ winamount }) =>
      winamount ? colors.secondary : colors.secondaryBackground};
    svg {
      width: 9px;
      margin-left: 2px;
      path {
        fill: ${({ winamount }) =>
          winamount ? colors.secondary : colors.secondaryBackground};
      }
    }
  }
`
export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  :last-child {
    padding-bottom: 30px;
  }
`
export const HistoryRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 0 0;
  max-width: 315px;
  overflow: hidden;
  flex-direction: row-reverse;
`

export const HistoryCard = styled.div<HISTORY_STYLED_PROPS>`
  width: 26px;
  height: 26px;
  margin: 0 6.5px;
  position: relative;
  :first-child {
    animation: ${({ addNewItem }) => addNewItem && "addHistory"};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    .item {
      opacity: 0;
      animation: ${({ addNewItem }) => addNewItem && "addItem"};
      opacity: ${({ addNewItem }) => (addNewItem ? 0 : 1)};
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
  }
  :nth-child(8) {
    width: 0;
    margin: 0;
    animation: ${({ removeOldItem }) => removeOldItem && "removeItemBox"};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    .item {
      display: ${({ removeOldItem }) => (removeOldItem ? "visible" : "none")};
      animation: ${({ removeOldItem }) => removeOldItem && "removeItem"};
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
  }
  div {
    background: ${({ background }) => background};
    border-radius: 30px;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    svg {
      position: absolute;
      width: 14px;
      height: 14px;
    }
  }

  @keyframes addHistory {
    0% {
      width: 0px;
    }
    100% {
      width: 26px;
    }
  }
  @keyframes addItem {
    0% {
      opacity: 0;
      transform: translateX(160px);
      animation-timing-function: cubic-bezier(0.35, 0, 0.35, 1);
    }
    1% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: translateX(0px);
    }
  }
  @keyframes removeItem {
    0% {
      transform: translateX(0px);
      animation-timing-function: cubic-bezier(0.35, 0, 0.35, 1);
    }
    100% {
      transform: translateX(-65px);
    }
  }
  @keyframes removeItemBox {
    0% {
      width: 26px;
    }
    100% {
      width: 0px;
      margin: 0px;
    }
  }
`
export const Button = styled.div<ACTION_STYLED_PROPS>`
  background: ${({ background }) => background};
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  color: ${colors.customColor};
  font-size: 20px;
  position: relative;
  transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  transition: transform 0.167s;
  ${({ anim }) => (anim ? "transform: scale(0.65);" : "transform: scale(1); ")}
  cursor: pointer;
  pointer-events: ${({ isClickable }) => (!isClickable ? "none" : "auto")};
  svg {
    width: 30px;
    height: 30px;
  }
  &.H {
    svg {
      width: 34px;
      height: 34px;
      padding: 5px 0 0 1px;
    }
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    transition: opacity 0.167s;
    ${({ anim }) => (anim ? "opacity: 0.5;" : "")}
  }
`

export const PrevCard = styled.div<CARD_STYLED_PROPS>`
  width: 127px;
  height: 196px;
  border-radius: 17px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
  background-color: ${colors.customColor};
  margin: 40px auto;
  padding: 15px 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: absolute;
  right: 50%;
  transform: translateX(50%);
  z-index: 2;
  top: -40px;
  ${({ changeCard }) => changeCard && cardChangeAnimation};
  p {
    font-size: 66px;
    color: ${(p) => p.color};
  }
  svg {
    width: 67.4px;
    height: 62.2px;
    path {
      fill: ${(p) => p.color};
    }
  }
`

export const CurrentCard = styled.div<CARD_STYLED_PROPS>`
  width: 127px;
  height: 196px;
  border-radius: 17px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
  background-color: ${colors.customColor};
  margin: 40px auto;
  padding: 15px 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  ${({ changeCard }) => changeCard && cardApearAnimation};
  p {
    font-size: 66px;
    color: ${(p) => p.color};
  }
  svg {
    width: 67.4px;
    height: 62.2px;
    path {
      fill: ${(p) => p.color};
    }
  }
`
